/**
 * Общая библиотека Framer Motion вариантов.
 *
 * Используй эти варианты для появления блоков/элементов — не дублируй по экранам.
 * Zацикленные CSS-эффекты (dotPulse, pulseRing, flyUp, inputShake, growW) — в globals.css.
 *
 * Паттерн:
 *   <motion.div variants={fadeSlide} initial="hidden" animate="visible">
 *   <motion.ul variants={staggerContainer(0.12)} initial="hidden" animate="visible">
 *     <motion.li variants={rise}>…</motion.li>
 *
 * MotionRoot.tsx оборачивает приложение в <MotionConfig reducedMotion="user"> —
 * трансформации гасятся автоматически; элементы видны и без анимации.
 */

import type { Variants } from 'framer-motion'

const EASE_OUT_SMOOTH = [0.2, 0.7, 0.2, 1] as const
const EASE_SPRING     = [0.2, 1.3, 0.4, 1] as const
const EASE_GENTLE     = [0.2, 0.9, 0.3, 1] as const
const EASE_POP        = [0.2, 1.2, 0.4, 1] as const

/** Блок появляется снизу + fade. Для секций, карточек, модалок. */
export const fadeSlide: Variants = {
  hidden:  { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: EASE_OUT_SMOOTH } },
}

/** Плитки баннера: пружинный pop, stagger 0.12 s. */
export const pop: Variants = {
  hidden:  { opacity: 0, scale: 0.7 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.5, ease: EASE_SPRING } },
}

/** Строки итогов: появляются снизу вверх, stagger 0.1–0.12 s. */
export const rise: Variants = {
  hidden:  { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: EASE_OUT_SMOOTH } },
}

/** Новое слово в списке трофеев. */
export const trophyIn: Variants = {
  hidden:  { opacity: 0, scale: 0.85, y: 12 },
  visible: { opacity: 1, scale: 1,    y: 0,  transition: { duration: 0.42, ease: EASE_GENTLE } },
}

/** Буква появляется по одной (letterIn, stagger ~0.06 s). */
export const letterIn: Variants = {
  hidden:  { opacity: 0, scale: 0.6, y: 8 },
  visible: { opacity: 1, scale: 1,   y: 0, transition: { duration: 0.32, ease: EASE_POP } },
}

/**
 * Хелпер stagger-контейнера.
 * @param stagger       задержка между дочерними элементами (с)
 * @param delayChildren начальная задержка перед первым ребёнком (с)
 */
export function staggerContainer(stagger = 0.12, delayChildren = 0): Variants {
  return {
    hidden:  {},
    visible: { transition: { staggerChildren: stagger, delayChildren } },
  }
}
